import { Button, Checkbox, TextField } from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import dayjs from "dayjs";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useEffect, useRef, useState } from "react";
import { common_brandgroup_GETROW } from "../../Server/ApiV2";
import { createMultiSelectOperator, createMultiSelectOperatorForBoolean } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";

export const columns = (setGridData,reviewMultiOptions,categoryMultiOptions,mainGrpMultiOptions,supGrpMultiOptions) => [
  {
    field: "RowId",
    headerName: "RowId",
    width: 75,
    hide: true,
    align: "center",
    headerAlign: "center",
    type: "number",
  },

  {
    field: "CategoryCdName",
    headerName: "Category",
    width: 160,
    align: "left",
    headerAlign: "left",
     filterOperators: [createMultiSelectOperator(categoryMultiOptions)],
  },
  {
    field: "IsReview",
    headerName: "Review",
    width: 50,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Checkbox
        size="small"
        sx={{
          transform: "scale(0.8)",
          padding: 0.5,
        }}
        checked={Boolean(params.value)}
        onChange={(e) => {
          const checked = e.target.checked === true;
          setGridData((prevRows) =>
            prevRows.map((row) =>
              row.RowId === params.id
                ? {
                    ...row,
                    IsReview: checked,
                    // ✅ flip isUpdated only when checked
                    isUpdated: checked ? true : row.isUpdated ?? false,
                  }
                : row
            )
          );
        }}
      />
    ),
    filterOperators: [createMultiSelectOperatorForBoolean(reviewMultiOptions)],
  },
  {
    field: "PL05_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Pending_Qty",
    headerName: "Pending Qty",
    width: 50,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Req_Qty",
    headerName: "ReqQty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL05_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  // PL10
  {
    field: "PL10_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Exess_Qty_During_LD",
    headerName: "ExessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",

    headerAlign: "center",
  },
  {
    field: "PL10_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL10_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // For PL15
  {
    field: "PL15_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL15_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // For PL20
  {
    field: "PL20_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL20_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // ==================== PL30 ====================
  {
    field: "PL30_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL30_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // ==================== PL40 ====================
  {
    field: "PL40_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL40_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // ==================== PL50 ====================
  {
    field: "PL50_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL50_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL40
  {
    field: "PL60_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL60_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL70
  {
    field: "PL70_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL70_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL80
  {
    field: "PL80_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL40
  {
    field: "PL90_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL90_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL40
  {
    field: "PL100_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL100_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL125
  {
    field: "PL125_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL80_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL125_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL150
  {
    field: "PL150_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL150_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL175
  {
    field: "PL175_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL175_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL200
  {
    field: "PL200_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL200_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL250
  {
    field: "PL250_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL250_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  {
    field: "PL300_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL300_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL350
  {
    field: "PL350_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL350_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL400
  {
    field: "PL400_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL400_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL450
  {
    field: "PL450_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL450_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },

  // PL500
  {
    field: "PL500_Max_SKU_Count",
    headerName: "Max.SKU",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Group_Retail_Sales",
    headerName: "Retail Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Group_Retail_Stock",
    headerName: "Retail Stock",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Group_Consm",
    headerName: "Consmp",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Pending_Qty",
    headerName: "Pending Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Lead_Days_Sales",
    headerName: "LD Sales",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Excess_Short_During_LD",
    headerName: "ExcessShort DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Exess_Qty_During_LD",
    headerName: "ExcessQty DuringLD",
    width: 60,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Req_Qty_Forecast_Days",
    headerName: "ReqQty FD",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Req_Qty",
    headerName: "Req.Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "PL500_Final_Qty",
    headerName: "Final Qty",
    width: 40,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "MainGroupName",
    headerName: "MainGroup",
    width: 120,
    align: "left",
    headerAlign: "left",
    filterOperators: [createMultiSelectOperator(mainGrpMultiOptions)],
  },
  {
    field: "SubGroupName",
    headerName: "SubGroup",
    width: 120,
    align: "left",
    headerAlign: "left",
    filterOperators: [createMultiSelectOperator(supGrpMultiOptions)],
  },
];

export const columnGroupingModel = [
  {
    groupId: "PL05",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL05_Max_SKU_Count" },
      { field: "PL05_Group_Retail_Sales" },
      { field: "PL05_Group_Retail_Stock" },
      { field: "PL05_Group_Consm" },
      { field: "PL05_Pending_Qty" },
      { field: "PL05_Lead_Days_Sales" },
      { field: "PL05_Excess_Short_During_LD" },
      { field: "PL05_Exess_Qty_During_LD" },
      { field: "PL05_Req_Qty_Forecast_Days" },
      { field: "PL05_Req_Qty" },
      { field: "PL05_Final_Qty" },
    ],
  },
  {
    groupId: "PL10",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL10_Max_SKU_Count" },
      { field: "PL10_Group_Retail_Sales" },
      { field: "PL10_Group_Retail_Stock" },
      { field: "PL10_Group_Consm" },
      { field: "PL10_Pending_Qty" },
      { field: "PL10_Lead_Days_Sales" },
      { field: "PL10_Excess_Short_During_LD" },
      { field: "PL10_Exess_Qty_During_LD" },
      { field: "PL10_Req_Qty_Forecast_Days" },
      { field: "PL10_Req_Qty" },
      { field: "PL10_Final_Qty" },
    ],
  },
  {
    groupId: "PL15",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL15_Max_SKU_Count" },
      { field: "PL15_Group_Retail_Sales" },
      { field: "PL15_Group_Retail_Stock" },
      { field: "PL15_Group_Consm" },
      { field: "PL15_Pending_Qty" },
      { field: "PL15_Lead_Days_Sales" },
      { field: "PL15_Excess_Short_During_LD" },
      { field: "PL15_Exess_Qty_During_LD" },
      { field: "PL15_Req_Qty_Forecast_Days" },
      { field: "PL15_Req_Qty" },
      { field: "PL15_Final_Qty" },
    ],
  },
  {
    groupId: "PL20",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL20_Max_SKU_Count" },
      { field: "PL20_Group_Retail_Sales" },
      { field: "PL20_Group_Retail_Stock" },
      { field: "PL20_Group_Consm" },
      { field: "PL20_Pending_Qty" },
      { field: "PL20_Lead_Days_Sales" },
      { field: "PL20_Excess_Short_During_LD" },
      { field: "PL20_Exess_Qty_During_LD" },
      { field: "PL20_Req_Qty_Forecast_Days" },
      { field: "PL20_Req_Qty" },
      { field: "PL20_Final_Qty" },
    ],
  },
  {
    groupId: "PL30",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL30_Max_SKU_Count" },
      { field: "PL30_Group_Retail_Sales" },
      { field: "PL30_Group_Retail_Stock" },
      { field: "PL30_Group_Consm" },
      { field: "PL30_Pending_Qty" },
      { field: "PL30_Lead_Days_Sales" },
      { field: "PL30_Excess_Short_During_LD" },
      { field: "PL30_Exess_Qty_During_LD" },
      { field: "PL30_Req_Qty_Forecast_Days" },
      { field: "PL30_Req_Qty" },
      { field: "PL30_Final_Qty" },
    ],
  },
  {
    groupId: "PL40",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL40_Max_SKU_Count" },
      { field: "PL40_Group_Retail_Sales" },
      { field: "PL40_Group_Retail_Stock" },
      { field: "PL40_Group_Consm" },
      { field: "PL40_Pending_Qty" },
      { field: "PL40_Lead_Days_Sales" },
      { field: "PL40_Excess_Short_During_LD" },
      { field: "PL40_Exess_Qty_During_LD" },
      { field: "PL40_Req_Qty_Forecast_Days" },
      { field: "PL40_Req_Qty" },
      { field: "PL40_Final_Qty" },
    ],
  },
  {
    groupId: "PL50",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL50_Max_SKU_Count" },
      { field: "PL50_Group_Retail_Sales" },
      { field: "PL50_Group_Retail_Stock" },
      { field: "PL50_Group_Consm" },
      { field: "PL50_Pending_Qty" },
      { field: "PL50_Lead_Days_Sales" },
      { field: "PL50_Excess_Short_During_LD" },
      { field: "PL50_Exess_Qty_During_LD" },
      { field: "PL50_Req_Qty_Forecast_Days" },
      { field: "PL50_Req_Qty" },
      { field: "PL50_Final_Qty" },
    ],
  },
  {
    groupId: "PL60",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL60_Max_SKU_Count" },
      { field: "PL60_Group_Retail_Sales" },
      { field: "PL60_Group_Retail_Stock" },
      { field: "PL60_Group_Consm" },
      { field: "PL60_Pending_Qty" },
      { field: "PL60_Lead_Days_Sales" },
      { field: "PL60_Excess_Short_During_LD" },
      { field: "PL60_Exess_Qty_During_LD" },
      { field: "PL60_Req_Qty_Forecast_Days" },
      { field: "PL60_Req_Qty" },
      { field: "PL60_Final_Qty" },
    ],
  },
  {
    groupId: "PL70",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL70_Max_SKU_Count" },
      { field: "PL70_Group_Retail_Sales" },
      { field: "PL70_Group_Retail_Stock" },
      { field: "PL70_Group_Consm" },
      { field: "PL70_Pending_Qty" },
      { field: "PL70_Lead_Days_Sales" },
      { field: "PL70_Excess_Short_During_LD" },
      { field: "PL70_Exess_Qty_During_LD" },
      { field: "PL70_Req_Qty_Forecast_Days" },
      { field: "PL70_Req_Qty" },
      { field: "PL70_Final_Qty" },
    ],
  },
  {
    groupId: "PL80",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL80_Max_SKU_Count" },
      { field: "PL80_Group_Retail_Sales" },
      { field: "PL80_Group_Retail_Stock" },
      { field: "PL80_Group_Consm" },
      { field: "PL80_Pending_Qty" },
      { field: "PL80_Lead_Days_Sales" },
      { field: "PL80_Excess_Short_During_LD" },
      { field: "PL80_Exess_Qty_During_LD" },
      { field: "PL80_Req_Qty_Forecast_Days" },
      { field: "PL80_Req_Qty" },
      { field: "PL80_Final_Qty" },
    ],
  },
  {
    groupId: "PL90",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL90_Max_SKU_Count" },
      { field: "PL90_Group_Retail_Sales" },
      { field: "PL90_Group_Retail_Stock" },
      { field: "PL90_Group_Consm" },
      { field: "PL90_Pending_Qty" },
      { field: "PL90_Lead_Days_Sales" },
      { field: "PL90_Excess_Short_During_LD" },
      { field: "PL90_Exess_Qty_During_LD" },
      { field: "PL90_Req_Qty_Forecast_Days" },
      { field: "PL90_Req_Qty" },
      { field: "PL90_Final_Qty" },
    ],
  },
  {
    groupId: "PL100",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL100_Max_SKU_Count" },
      { field: "PL100_Group_Retail_Sales" },
      { field: "PL100_Group_Retail_Stock" },
      { field: "PL100_Group_Consm" },
      { field: "PL100_Pending_Qty" },
      { field: "PL100_Lead_Days_Sales" },
      { field: "PL100_Excess_Short_During_LD" },
      { field: "PL100_Exess_Qty_During_LD" },
      { field: "PL100_Req_Qty_Forecast_Days" },
      { field: "PL100_Req_Qty" },
      { field: "PL100_Final_Qty" },
    ],
  },
  {
    groupId: "PL125",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL125_Max_SKU_Count" },
      { field: "PL125_Group_Retail_Sales" },
      { field: "PL125_Group_Retail_Stock" },
      { field: "PL125_Group_Consm" },
      { field: "PL125_Pending_Qty" },
      { field: "PL125_Lead_Days_Sales" },
      { field: "PL125_Excess_Short_During_LD" },
      { field: "PL125_Exess_Qty_During_LD" },
      { field: "PL125_Req_Qty_Forecast_Days" },
      { field: "PL125_Req_Qty" },
      { field: "PL125_Final_Qty" },
    ],
  },
  {
    groupId: "PL150",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL150_Max_SKU_Count" },
      { field: "PL150_Group_Retail_Sales" },
      { field: "PL150_Group_Retail_Stock" },
      { field: "PL150_Group_Consm" },
      { field: "PL150_Pending_Qty" },
      { field: "PL150_Lead_Days_Sales" },
      { field: "PL150_Excess_Short_During_LD" },
      { field: "PL150_Exess_Qty_During_LD" },
      { field: "PL150_Req_Qty_Forecast_Days" },
      { field: "PL150_Req_Qty" },
      { field: "PL150_Final_Qty" },
    ],
  },
  {
    groupId: "PL175",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL175_Max_SKU_Count" },
      { field: "PL175_Group_Retail_Sales" },
      { field: "PL175_Group_Retail_Stock" },
      { field: "PL175_Group_Consm" },
      { field: "PL175_Pending_Qty" },
      { field: "PL175_Lead_Days_Sales" },
      { field: "PL175_Excess_Short_During_LD" },
      { field: "PL175_Exess_Qty_During_LD" },
      { field: "PL175_Req_Qty_Forecast_Days" },
      { field: "PL175_Req_Qty" },
      { field: "PL175_Final_Qty" },
    ],
  },

  {
    groupId: "PL200",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL200_Max_SKU_Count" },
      { field: "PL200_Group_Retail_Sales" },
      { field: "PL200_Group_Retail_Stock" },
      { field: "PL200_Group_Consm" },
      { field: "PL200_Pending_Qty" },
      { field: "PL200_Lead_Days_Sales" },
      { field: "PL200_Excess_Short_During_LD" },
      { field: "PL200_Exess_Qty_During_LD" },
      { field: "PL200_Req_Qty_Forecast_Days" },
      { field: "PL200_Req_Qty" },
      { field: "PL200_Final_Qty" },
    ],
  },
  {
    groupId: "PL250",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL250_Max_SKU_Count" },
      { field: "PL250_Group_Retail_Sales" },
      { field: "PL250_Group_Retail_Stock" },
      { field: "PL250_Group_Consm" },
      { field: "PL250_Pending_Qty" },
      { field: "PL250_Lead_Days_Sales" },
      { field: "PL250_Excess_Short_During_LD" },
      { field: "PL250_Exess_Qty_During_LD" },
      { field: "PL250_Req_Qty_Forecast_Days" },
      { field: "PL250_Req_Qty" },
      { field: "PL250_Final_Qty" },
    ],
  },
  {
    groupId: "PL300",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL300_Max_SKU_Count" },
      { field: "PL300_Group_Retail_Sales" },
      { field: "PL300_Group_Retail_Stock" },
      { field: "PL300_Group_Consm" },
      { field: "PL300_Pending_Qty" },
      { field: "PL300_Lead_Days_Sales" },
      { field: "PL300_Excess_Short_During_LD" },
      { field: "PL300_Exess_Qty_During_LD" },
      { field: "PL300_Req_Qty_Forecast_Days" },
      { field: "PL300_Req_Qty" },
      { field: "PL300_Final_Qty" },
    ],
  },
  {
    groupId: "PL350",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL350_Max_SKU_Count" },
      { field: "PL350_Group_Retail_Sales" },
      { field: "PL350_Group_Retail_Stock" },
      { field: "PL350_Group_Consm" },
      { field: "PL350_Pending_Qty" },
      { field: "PL350_Lead_Days_Sales" },
      { field: "PL350_Excess_Short_During_LD" },
      { field: "PL350_Exess_Qty_During_LD" },
      { field: "PL350_Req_Qty_Forecast_Days" },
      { field: "PL350_Req_Qty" },
      { field: "PL350_Final_Qty" },
    ],
  },
  {
    groupId: "PL400",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL400_Max_SKU_Count" },
      { field: "PL400_Group_Retail_Sales" },
      { field: "PL400_Group_Retail_Stock" },
      { field: "PL400_Group_Consm" },
      { field: "PL400_Pending_Qty" },
      { field: "PL400_Lead_Days_Sales" },
      { field: "PL400_Excess_Short_During_LD" },
      { field: "PL400_Exess_Qty_During_LD" },
      { field: "PL400_Req_Qty_Forecast_Days" },
      { field: "PL400_Req_Qty" },
      { field: "PL400_Final_Qty" },
    ],
  },
  {
    groupId: "PL450",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL450_Max_SKU_Count" },
      { field: "PL450_Group_Retail_Sales" },
      { field: "PL450_Group_Retail_Stock" },
      { field: "PL450_Group_Consm" },
      { field: "PL450_Pending_Qty" },
      { field: "PL450_Lead_Days_Sales" },
      { field: "PL450_Excess_Short_During_LD" },
      { field: "PL450_Exess_Qty_During_LD" },
      { field: "PL450_Req_Qty_Forecast_Days" },
      { field: "PL450_Req_Qty" },
      { field: "PL450_Final_Qty" },
    ],
  },
  {
    groupId: "PL500",
    align: "center",
    headerAlign: "center",
    children: [
      { field: "PL500_Max_SKU_Count" },
      { field: "PL500_Group_Retail_Sales" },
      { field: "PL500_Group_Retail_Stock" },
      { field: "PL500_Group_Consm" },
      { field: "PL500_Pending_Qty" },
      { field: "PL500_Lead_Days_Sales" },
      { field: "PL500_Excess_Short_During_LD" },
      { field: "PL500_Exess_Qty_During_LD" },
      { field: "PL500_Req_Qty_Forecast_Days" },
      { field: "PL500_Req_Qty" },
      { field: "PL500_Final_Qty" },
    ],
  },
];

export const initialError = {
  TransId: "",
  Date: "",
  TransLoc: "",
  Group: "",
  FromDate: "",
  ToDate: "",
  Loc: "",
  LeadDays: "",
  ForecastDays: "",
  TripId:"",
};

export const fValidation = (formData, setErrors) => {
  let isValid = true;
  const newError = { ...initialError };
  const today = dayjs().startOf("day");

  const requiredFields = [
    { key: "TransId", label: "TransId" },
    { key: "Date", label: "TransDate" },
    { key: "TransLoc", label: "TransLoc" },
    { key: "Group", label: "MainGroup" }, // <-- array
    { key: "FromDate", label: "AnalysisFromDate" },
    { key: "ToDate", label: "AnalysisToDate" },
    { key: "Loc", label: "AnalysisLoc" }, // <-- array
    { key: "LeadDays", label: "Lead Days" },
    { key: "ForecastDays", label: "Forecast Days" },
    {key:"TripId",label:"Trip ID"},
  ];

  // ✅ Basic required check including array validation
  for (const field of requiredFields) {
    const value = formData?.[field.key];

    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0) // check for empty array
    ) {
      newError[field.key] = `${field.label} is required.`;
      isValid = false;
    }
  }

  // ✅ Normalize any type to Day.js
  const normalizeDate = (dateValue) => {
    if (!dateValue) return null;
    if (dayjs.isDayjs(dateValue)) return dateValue; // Already Day.js
    if (dateValue instanceof Date) return dayjs(dateValue); // JS Date
    if (typeof dateValue === "string") {
      let parsed = dayjs(dateValue, "DD/MM/YYYY", true);
      if (!parsed.isValid()) parsed = dayjs(dateValue, "MM/DD/YYYY", true);
      if (!parsed.isValid()) parsed = dayjs(dateValue); // Fallback
      return parsed.isValid() ? parsed : null;
    }
    return null;
  };

  const fromDate = normalizeDate(formData.FromDate);
  const toDate = normalizeDate(formData.ToDate);

  // ✅ FromDate checks
  if (formData.FromDate) {
    if (!fromDate) {
      newError.FromDate = "Invalid From Date.";
      isValid = false;
    } else if (fromDate.isAfter(today)) {
      newError.FromDate = "From Date cannot be in the future.";
      isValid = false;
    }
  }

  // ✅ ToDate checks
  if (formData.ToDate) {
    if (!toDate) {
      newError.ToDate = "Invalid To Date.";
      isValid = false;
    } else if (toDate.isBefore(fromDate)) {
      newError.ToDate = "To Date cannot be before From Date.";
      isValid = false;
    }
  }

  // ✅ Relationship check
  if (fromDate && toDate) {
    if (fromDate.isAfter(toDate)) {
      newError.FromDate = "From Date cannot be after To Date.";
      isValid = false;
    }
  }

  // ✅ Update errors
  setErrors((prevError) => ({
    ...prevError,
    ...newError,
  }));

  // ✅ Focus first invalid field
  if (!isValid) {
    const firstInvalid = Object.keys(newError).find((key) => newError[key]);
    document.querySelector(`[name="${firstInvalid}"]`)?.focus();
  }

  return isValid;
};

export const PL_BUCKETS = [
  "PL05",
  "PL10",
  "PL15",
  "PL20",
  "PL30",
  "PL40",
  "PL50",
  "PL60",
  "PL70",
  "PL80",
  "PL90",
  "PL100",
  "PL125",
  "PL150",
  "PL175",
  "PL200",
  "PL250",
  "PL300",
  "PL350",
  "PL400",
  "PL450",
  "PL500",
];

export default function CustomToolbarWithMenu({
  setOpenContentModal,
  aMediaQuery,
  sOpenFilterModal,
  setOpenFilterModal,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "8px",
        height: aMediaQuery ? "" : "24px",
        paddingRight: "4px",
      }}
    >
      <GridToolbar />
      <div>
        <Button
          variant="outlined"
          sx={{
            padding: "1px 6px !important",
            minWidth: "30px !important",
            justifyContent: "center",
            textAlign: "center",
            marginRight: "8px",
          }}
          onClick={() => {
            setOpenFilterModal(true);
          }}
        >
          FORMULA
        </Button>
        <Button
          variant="outlined"
          sx={{
            padding: "1px 6px !important",
            minWidth: "30px !important",
            justifyContent: "center",
            textAlign: "center",
          }}
          onClick={() => {
            setOpenContentModal(true);
          }}
        >
          <MoreHorizIcon fontSize="small" />
        </Button>
      </div>
    </div>
  );
}

export const FinalQtyEditCell = ({ id, field, value, api }) => {
  const inputRef = useRef();

  useEffect(() => {
    // Auto-focus when cell opens
    if (inputRef.current) {
      inputRef.current.focus();
      if (String(value) === "0") {
        // Clear field on focus if 0
        api.setEditCellValue({ id, field, value: "" });
      }
    }
  }, [id, field, value, api]);

  const handleChange = (e) => {
    const newValue = e.target.value;

    // Block decimal
    if (newValue.includes(".")) return;

    // Allow only digits
    if (/^\d*$/.test(newValue)) {
      api.setEditCellValue({ id, field, value: newValue }, e);
    }
  };

  return (
    <TextField
      inputRef={inputRef}
       value={value === 0 ? "" : value ?? ""}
      onChange={handleChange}
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        style: { textAlign: "center" },
      }}
      fullWidth
      variant="standard"
    />
  );
};

export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
// Helpers to parse CSV strings and build the basket array for GCBrandSearch
// utils/brand.js
// utils/brand.js
// utils/brand.js
function normalizeDelimiters(s) {
  if (s == null) return "";
  return String(s)
    .replace(/[|;،\n\r\t]+/g, ",") // pipes/semicolons/Arabic comma/newlines -> comma
    .replace(/,+/g, ","); // collapse multiple commas
}

export function splitCsvSmart(s) {
  if (s == null) return [];
  return normalizeDelimiters(s)
    .split(",")
    .map((x) => x.replace(/\s+/g, " ").trim()) // squeeze spaces & trim
    .filter(Boolean);
}

export function buildBrandArray(aBrandCd, brandName) {
  const codes = splitCsvSmart(aBrandCd);
  const names = splitCsvSmart(brandName);

  const len = Math.max(codes.length, names.length);
  const arr = [];

  for (let i = 0; i < len; i++) {
    const Cd = codes[i] ?? "";
    const Name1 = (names[i] ?? names[names.length - 1] ?? "").trim();
    if (Cd || Name1) {
      arr.push({
        UID: Cd || Name1,
        Name1,
        Cd,
        Group: "GENERAL",
        id: i + 1,
        value: Cd || Name1,
        label: Name1 || Cd,
      });
    }
  }

  // if both arrays empty but we still have a raw string, create one fallback
  if (arr.length === 0) {
    const fallbackCd = splitCsvSmart(aBrandCd)[0] || "";
    const fallbackName = splitCsvSmart(brandName)[0] || "";
    if (fallbackCd || fallbackName) {
      arr.push({
        UID: fallbackCd || fallbackName,
        Name1: fallbackName,
        Cd: fallbackCd,
        Group: "GENERAL",
        id: 1,
        value: fallbackCd || fallbackName,
        label: fallbackName || fallbackCd,
      });
    }
  }

  return arr;
}
